import { inject, injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type BonusInfoService from '@/services/domain/bonusInfoService'
import type { FeatureFlagsService } from '@/services/featureFlagsService'
import { FeatureFlags } from '@/services/types'
import type { IMainServerSub, TServerEvent } from '@/services/transport/serverEvents'

@injectable()
export default class BonusInfoResolver implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.FeatureFlagsService)
    protected readonly featureFlagsService: FeatureFlagsService,
    @inject(SERVICE_TYPES.BonusInfoService)
    protected readonly bonusInfoService: BonusInfoService,
    @inject(SERVICE_TYPES.ServerSubscriptionService)
    private readonly serverSubscriptionService: IMainServerSub,
  ) {}

  private emailBonusUpdatedHandler = (e: TServerEvent<'emailBonusUpdated'>) => {
    this.bonusInfoService.updateBonusInfo({
      emails: e.payload.emails,
      emailLookups: e.payload.lookups,
      emailStatus: e.payload.status,
    })
  }

  public async resolve() {
    if (!this.featureFlagsService.isFeatureEnabled(FeatureFlags.EmailBonus)) {
      return
    }
    this.serverSubscriptionService.subscribe('emailBonusUpdated', this.emailBonusUpdatedHandler)
    this.bonusInfoService.fillInfoBonus()
  }

  public async unresolve() {
    this.serverSubscriptionService.unsubscribe('emailBonusUpdated', this.emailBonusUpdatedHandler)
  }
}
